import { action, makeObservable, observable, runInAction } from 'mobx';

import { inject, injectable } from '@servicetitan/react-ioc';

import { APP_API_TOKEN, IAppApi } from '../../api/app.api';
import { AUTH_STORE_TOKEN, IAuthStore } from '../../auth';

@injectable()
export class TermsStore {
    @observable accepted: boolean | null = null;
    @observable accepting = false;

    constructor(
        @inject(APP_API_TOKEN) private readonly appApi: IAppApi,
        @inject(AUTH_STORE_TOKEN) private readonly authStore: IAuthStore,
    ) {
        makeObservable(this);
        this.appApi
            .hasAcceptedSiteTerms()
            .then(accepted => {
                runInAction(() => {
                    this.accepted = accepted;
                });
            })
            .catch(() => {
                runInAction(() => {
                    this.accepted = false;
                });
            });
    }

    @action.bound
    async handleAccept(): Promise<void> {
        this.accepting = true;
        try {
            await this.appApi.acceptSiteTerms();
            runInAction(() => {
                this.accepted = true;
                this.accepting = false;
            });
        } catch {
            runInAction(() => {
                this.accepting = false;
            });
        }
    }

    handleDecline = (): Promise<void> => {
        return this.authStore.signOut();
    };
}
